<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17LmP14/tc-custom/9781466859159.jpg?1731726887789" alt="This image is the cover for the book Smells Like Finn Spirit, The Familia Arcana"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Smells Like Finn Spirit, The Familia Arcana
      </h1>
      <p class="bookDescription body article font2">
        <p>Finn Graymare is back in the final installment of Randy Henderson's Familia Arcana series, <i>Smells Like Finn Spirit.</i><br/><br/>Finn's re-adaptation to the human world is not going so well.  He's got a great girlfriend, and is figuring out how things like the internet work, but he is still carrying the disembodied personality of Alynon, Prince of the Silver Demesne, the fae who had occupied his body during his imprisonment.  And he's not getting along at all with his older brother.  And oh, by the way, his dead grandfather is still trying to possess him in order to bring about Armageddon.<br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Randy Henderson
      </h2>
      
      <p class="authorDescription body article">RANDY HENDERSON, author of <I>Finn Fancy Necromancy</I>, and <I>Bigfootloose and Finn Fancy Free</I>, is the grand prize winner of Writers of the Future Award, a Clarion West graduate, and member of SFWA and Codex. His fiction has appeared in <I>Penumbra</I>, <I>Escape Pod</I>, and <I>Realms of Fantasy</I>, and has been included in anthologies.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5a51a164